import React, { useState, createContext } from "react";


export const ResultsContext = createContext();

export default function ResultsProvider(props) {
    
  const [isoutput,setisoutput]=useState(true);
  const { children } = props;

  const data ={
    isoutput,
    setisoutput,
  }

  return <ResultsContext.Provider value={data}>{children}</ResultsContext.Provider>;
}